import Seo from '../components/Seo.jsx';
import Hero from '../sections/Hero.jsx';
import StatsBand from '../sections/StatsBand.jsx';
import TrustLogos from '../sections/TrustLogos.jsx';
import ResultsBanner from '../sections/ResultsBanner.jsx';
import Testimonials from '../sections/Testimonials.jsx';
import InAction from '../sections/InAction.jsx';
import ComparisonTable from '../sections/ComparisonTable.jsx';
import PricingSection from '../sections/PricingSection.jsx';

/**
 * Section order alternates dark and light all the way down:
 *
 *   Hero (dark) → Trust (light) → Results (dark) → Testimonial (light)
 *   → In action (dark) → Comparison (light) → Pricing (dark)
 *
 * Two dark sections in a row read as one broken section rather than two, so
 * anything reordered here needs its background checked against its neighbours.
 */
export default function Home() {
  return (
    <>
      <Seo path="/" />
      <Hero />
      <StatsBand />
      <TrustLogos />
      {/* Who uses it, then immediately what it did for them. */}
      <ResultsBanner />
      {/* The numbers, then a customer saying it in her own words. */}
      <Testimonials />
      {/* Her words, then the photographic evidence: installs, walk-throughs
          and the system running on real farms. */}
      <InAction />
      {/* What you get, immediately followed by what it costs. */}
      <ComparisonTable />
      <PricingSection />
    </>
  );
}
